// 问卷库模块
export default {
    QuesLibrary: {
        QuestionnaireType: 'Jenis Soal Selidik',
        TemplatSistem: 'Templat Sistem',
        TemplatSaya: 'Templat Saya',
        BankSoalanSaya: 'Bank Soalan Saya',
        BankSoalanSistem: ' Bank Soalan Sistem',
        QuestionBankAnalysis: 'Analisi Bank Soalan',
        LabelMasalah: 'Label Soalan',
        PengurusanMasalah: 'Pengurusan Soalan',
        Tambah: 'Tambah',
        Name: 'Nama',
        SortOrder: 'Isih ikut',
        Operate: 'Operasi',
        AreYouSureToDeleteIt: 'Pastikah anda ingin memadamkan?',
        Delete: 'Padam',
        Edit: 'Edit',
        NewlyAdded: 'Baru tambah',
        ModifySortingPosition: 'Ubahsuai posisi pengisihan',
        Category: 'Kategori',
        SortPosition: 'Posisi pengisihan',
        PleaseEnterAName: 'Sila masukkan nama',
        SelectCategory: 'Pilih kategori',
        PleaseSelectCategory: 'Sila pilih kategori',
        All: 'Semua',
        QuestionnaireName: 'Nama Soal Selidik',
        NumberOfCitations: 'Nombor petikan',
        Type: 'Jenis',
        DesignQuestionnaire: 'Cipta Soal Selidik',
        Preview: 'Pratonton',
        Modify: 'Ubahsuai',
        MyTemplate: 'Templat Saya',
        CannotExceed5MB: 'Gambar untuk dimuat naik tidak boleh lebih besar daripada 5MB，sila pilih sekali lagi!',
        PleaseUploadPictures: 'Sila muat naik gambar',
        QuestionBankList: 'Senaria bank soalan',
        NumberOfRecords: 'Nombor rekod',
        Refresh: 'Segar semula',
        SearchQuestionBankName: 'Sila masuskkan nama bank soalan untuk mencari',
        SearchQuestionBankCategories: 'Sila masuskkan kategori bank soalan untuk mencari',
        Query: 'Pertanyaan',
        CreateANewQuestionBank: 'Bina bank soalan baruk',
        QuestionBankNumber: 'Nombor bank soalan',
        None: 'Tiada',
        QuestionBankName: 'Nama bank soalan',
        QuestionBankCategory: 'Kategori bank soalan',
        Creator: 'Pembina',
        NumberOfTestQuestions: 'Nombor soalan',
        Memo: 'Memo',
        CreateQuestion: 'Cipta soalan',
        EditQuestion: 'Edit soalan',
        EditQuestionBank: 'Edit bank soalan',
        AddQuestionBank: 'Tambah bank soalan',
        QuestionBankInfo: 'Maklumat bank soalan',
        ConfirmDeletionOfQuestionBank: 'Padamkan bank soalan?',
        SelectTheQuestionBankToDelete: 'Sila pilih bank soalan yang hendak dipadamkan',
        DeletSelectedQuestionBank: 'Padamkan bank soalan yang dipilih?',
        CancelTheSelectedQuestionBank: 'Batalkan pemadaman bank soalan yang dipilih?',
        CancelFavorite: 'Batalkan simpanan kegemaran',
        Prompt: 'Gesaan',
        ChooseAQuestionBankToBookmark: 'Sila pilih bank soalan untuk menambah tanda halaman',
        CanceledSuccessfully: 'Pembatalan berjaya',
        QuestionBankNumberLimit: '1-32 aksara, dengan menggunakan huruf, nombor, garis bawah',
        EnterOrSelectArticleLabel: 'Masukan/pilih label artikel',
        Notes: 'Nota',
        Save: 'Simpan',
        Resetting: 'Set semula',
        CharacterMismatch: 'Sila gunakan huruf, nombor, garis bawah',
        LengthMismatch: '1 hingga 32 aksara kepanjangnya',
        EnterTheNameOfTheQuestionBank: 'Sila masukkan nama bank soalan',
        EnterQuestionBankCategory: 'Sila masukkan kategori bank soalan',
        EnterQuestionBankNotes: 'Sila masukkan nota untuk bank soalan',
        SelfBuiltQuestionBank: 'Bank soalan bina sendiri',
        DeleteQuestionBankFromFavoritesList: 'Padamkan bank soalan daripada senarai kegemaran?',
        ChooseToCancelTheFavoriteQuestionBank: 'Sila pilih bank soalan yang hendak dipadamkan daripada senarai kegemmaran',
        QuestionLabelName: 'Nama label soalan',
        AddQuestionLabel: 'Tambah label soalan',
        TagName: 'Nama tag',
        ModifyProblemLabels: 'Ubahsuai label soalan',
        DeleteTitleTip: 'Semua soalan di dalam kumpulan akan dipadamkam selepas pengesahan pemandaman',
        DeleteConfirmation: 'Pengesahan pemandaman',
        ExportData: 'Eskport data',
        NumberOfRespondents: 'Nombor responden',
        NumberOfRespondents: 'Nombor responden',
        Download: 'Muat turun',
        LoadMore: 'Muat lagi',
        ModificationPrompt: 'Gesaan pengubahsuaian',
        ConfirmModifyingTheQuestionnaire: 'Pastikah anda ingin mengubahsuai soalselidik ini? Semua kumpulan data akan dihentikan，pautan soal selidik akan ditutup!',
        DataType: 'Jenis data',
        RawData: 'Data mentah',
        CodedData: 'Data yang dikodkan',
        ExhibitionFormat: 'Format paparan',
        OneQuestionOneColumn: 'Satu lajur satu soalan',
        OneQuestionWithMultipleColumns: 'pelbagai lajur satu soalan',
        Export: 'Eksport',
        CustomTitle: 'Tajuk tersuai',
        Pie: 'Carta Pai',
        Histogram: 'Histogram',
        BarChart: 'Carta Bar',
        Ring: 'Carta Sinaran',
        StackedBarChart: 'Carta Lajur Bertindan',
        StackedBarChart2: 'Carta Bar Bertindan',
        RadarChart: 'Carta Radar',
        ProblemList: 'Senarai soalan',
        MultipleChoiceBank: 'Sila pilih beberapa bank soalan',
        EnterQuestionName: 'Sila masukkan nama soalan',
        EnterQuestionnaireLabel: 'Sila masukkan label soalan',
        ConfirmDeletionSelectedIssues: 'Padamkan soalan yang telah dipilih?',
        IssueNames: 'Nama soalan',
        AffiliatedQuestionBank: 'Kepunyaan bank soalan',
        QuestionnaireLabel: 'Label soal selidik',
        AreYouSureToDeleteTheIssue: 'Padamkan soalan?',
        Easy: 'Senang',
        Easier: 'Lebih senang',
        Middle: 'Sederhana',
        RelativelyDifficult: 'Lebig susah',
        Difficult: 'Susah',
        NoLimit: 'Tiada had',
        Radio: 'Pilih satu',
        SelectTheQuestionToDelete: 'Sila pilih soalan yang hendak dipadamkan',
        TestQuestionManagement: 'Pengurusan soalan',
        EditItem: 'Edit item',
        Success: 'Berjaya'
    },
  };